export default __webpack_public_path__ + "static/media/report.f9fd9160.svg";